var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0E3295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80257 12.4863C8.78514 12.0277 8.89526 11.5733 9.1206 11.174L9.30044 10.8553C9.73795 10.0799 10.5574 9.60059 11.4456 9.60059H15.9579C16.3673 9.60059 16.7703 9.7029 17.1305 9.89829L20.0592 11.4871C20.4193 11.6825 20.8223 11.7848 21.2318 11.7848H37.2957C38.6857 11.7848 39.8008 12.9371 39.7596 14.3309L39.3307 28.8376C39.2912 30.1741 38.1997 31.237 36.8668 31.237H11.8882C10.5634 31.237 9.47547 30.1865 9.42498 28.8585L8.80257 12.4863Z",
    fill: "#A5A5B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 15.4114C10.668 14.592 11.3301 13.9277 12.147 13.9277H36.6326C37.4495 13.9277 38.1116 14.592 38.1116 15.4114V27.4453C38.1116 28.2647 37.4495 28.929 36.6326 28.929H12.147C11.3301 28.929 10.668 28.2647 10.668 27.4453V15.4114Z",
    fill: "#FEFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86907 20.8563C8.81959 19.6851 9.75279 18.7085 10.9214 18.7085H37.6943C38.8629 18.7085 39.7961 19.6851 39.7466 20.8563L39.099 36.1873C39.0524 37.2904 38.1474 38.1606 37.0467 38.1606H11.569C10.4683 38.1606 9.56325 37.2904 9.51665 36.1873L8.86907 20.8563Z",
    fill: "#C4C4CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/AppIcon.ffed8c2a43edb484baf6cb3c30c183e1.svg";
export { ForwardRef as ReactComponent };